import React, { useEffect, useState } from "react";
import plusIcon from "../../../../../Assets/Images/Svg/plusIcon.svg";
import { Modal } from "antd";
import AddPastMedicalHistory from "./AddPastMedicalHistory";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import moment from "moment";
import { useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import dayjs from "dayjs";

function PastMedicalHistory({ permissionData }) {
  const [pastHistoryData, setPastHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);

  useEffect(() => {
    PastHistory();
  }, [permissionData]);

  const PastHistory = () => {
    const patientRaw = localStorage.getItem("patient");
    let patientData = patientRaw ? JSON.parse(patientRaw) : null;

    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    const patientId = patientData?.patientId || selectedRpmPatient?.patientId;

    if (permissionData) {
      let payload = {
        // account_Id: userData?.user?.account_Id,
        // clinic_Id: userData?.user?.clinic_Id,
        userId:
          permissionData === null || permissionData?.medicalHistory === "N"
            ? userData?.user?.userId
            : "",
        patientId,
        status: 1,
      };
      MedicalHistoryService.PastMedicalHistory(payload).then((result) => {
        setPastHistoryData(result.data);
      });
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleLatestUpdate = (data) => {
    setPastHistoryData(data);
  };

  return (
    <>
      <div>
        {/* <div className="card h-[300px] m-5 border rounded-lg">
          <div className="header h-[20%] bg-brand-primaryColor flex items-center justify-between rounded-lg p-2">
            <h1 className="font-bold text-normal text-white mt-2">
              Past Medical History
            </h1>
            <img
              src={plusIcon}
              onClick={showModal}
              className="h-10 w-10 cursor-pointer"
              alt=""
            />
          </div>
          <div className="body h-[70%] bg-[#DEF3F2] overflow-y-auto custom-scrollbar">
            {pastHistoryData.length > 0
              ? pastHistoryData.map((user, i) => (
                <div>
                  <div
                    key={i}
                    className="flex justify-between items-center p-2"
                  >
                    <div className="font-semibold text-sm">{user.pastInfo}</div>
                  </div>
                  <div className="flex justify-end font-medium text-sm">
                    check up date : {user.givenDate?.slice(0, 11)}
                  </div>
                  <hr className="my-2 border-gray-300" />
                </div>
              ))
              : null}
          </div>
          <div className="footer h-[10%]  bg-brand-primaryColor rounded-md"></div>
        </div> */}
        <div
          className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
          id="unquie-scroll"
        >
          <div className="flex justify-between items-center p-3">
            <h3 className="text-sm font-bold text-gray-700">
              Past Medical History
            </h3>
            <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
              <div
                onClick={showModal}
                className="w-6 h-6 rounded-full flex items-center justify-center bg-brand-primaryColor"
              >
                <FiPlus className="text-white w-4 h-4" />
              </div>
              {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
            </div>
          </div>
          <hr />
          <div className="h-52 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
            {pastHistoryData.length > 0 ? (
              pastHistoryData.map((user, i) => (
                <div className="relative">
                  <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                    <div className="bg-[#F9F8FF] border border-[#B9ADFF] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                      <p>
                        <strong> {user.pastInfo}</strong>
                      </p>
                      <p>
                        Onset Date :{" "}
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
      <Modal
        title={
          <span className="font-bold text-base">
            Add Past Medical History Details
          </span>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <AddPastMedicalHistory
          onClose={handleCancel}
          handleLatestUpdate={handleLatestUpdate}
          permissionData={permissionData}
        />
      </Modal>
    </>
  );
}

export default PastMedicalHistory;
